import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './Products.scss';
import Sloutions from '../../SmallComponents/SolutionComponent';
import SeamlessComfortPolo from '../../assets/images/products/Seamless Comfort Polo.png';
import SeamlessPerformanceTee from '../../assets/images/products/SeamlessPerformanceTee.png';
import SeamlessActiveTShirt from '../../assets/images/products/Seamless Active T-Shirt.png';
import SeamlessZipUpHoodie from '../../assets/images/products/SeamlessZipUpHoodie.webp';
import SeamlessTrainingJoggers from '../../assets/images/products/Seamless Training Joggers.png';
import SeamlessSlimFitPants from '../../assets/images/products/Seamless Slim Fit Pants.png';
import SeamlessHighWaistLeggings from '../../assets/images/products/Seamless High-Waist Leggings.png';
import SeamlessYogaCropTop from '../../assets/images/products/Seamless Yoga Crop Top.png';
import SeamlessSportsBra from '../../assets/images/products/Seamless Sports Bra.png';
import SeamlessSculptingBodysuit from '../../assets/images/products/Seamless Sculpting Bodysuit.png';
import SeamlessLoungeShorts from '../../assets/images/products/Seamless Lounge Shorts.png';
import SeamlessBikerShorts from '../../assets/images/products/Seamless Biker Shorts.png';

const Products: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get('category') || 'All Products';
  const [searchTerm, setSearchTerm] = useState('');

  const products = [
    { id: 1, name: "Seamless Performance Tee", category: "Mens-Tshirts", image: SeamlessPerformanceTee, description: "High-performance seamless workout tee.", price: 29.99, stock: 15 },
    { id: 2, name: "Seamless Comfort Polo", category: "Mens-Tshirts", image: SeamlessComfortPolo, description: "Breathable and stylish polo shirt.", price: 34.99, stock: 12 },
    { id: 3, name: "Seamless Active T-Shirt", category: "Mens-Tshirts", image: SeamlessActiveTShirt, description: "Lightweight and soft seamless tee.", price: 24.99, stock: 20 },
    { id: 4, name: "Seamless Zip-Up Hoodie", category: "Mens-Tshirts", image: SeamlessZipUpHoodie, description: "Stylish and warm seamless hoodie.", price: 49.99, stock: 8 },
    { id: 5, name: "Seamless Training Joggers", category: "Mens-Pants", image: SeamlessTrainingJoggers, description: "Flexible and comfortable joggers.", price: 39.99, stock: 10 },
    { id: 6, name: "Seamless Slim Fit Pants", category: "Womens-Pants", image: SeamlessSlimFitPants, description: "Stretchable and modern design.", price: 44.99, stock: 5 },
    { id: 7, name: "Seamless High-Waist Leggings", category: "Womens-Sports", image: SeamlessHighWaistLeggings, description: "Ultimate comfort and flexibility.", price: 49.99, stock: 20 },
    { id: 8, name: "Seamless Yoga Crop Top", category: "Womens-Sports", image: SeamlessYogaCropTop, description: "Perfect for yoga and workouts.", price: 24.99, stock: 15 },
    { id: 9, name: "Seamless Sports Bra", category: "Seamless-Bra", image: SeamlessSportsBra, description: "Supportive and breathable sports bra.", price: 29.99, stock: 30 },
    { id: 10, name: "Seamless Sculpting Bodysuit", category: "Seamless-Bra", image: SeamlessSculptingBodysuit, description: "Shaping and contouring bodysuit.", price: 39.99, stock: 18 },
    { id: 11, name: "Seamless Lounge Shorts", category: "Womens-Shorts", image: SeamlessLoungeShorts, description: "Soft and comfortable lounge shorts.", price: 19.99, stock: 25 },
    { id: 12, name: "Seamless Biker Shorts", category: "Womens-Shorts", image: SeamlessBikerShorts, description: "Flexible and stylish biker shorts.", price: 22.99, stock: 22 }
  ];

  const filteredProducts = products.filter((product) => 
    (category === 'All Products' || product.category === category) &&
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  

  return (
    <>
    <div className="products-page">
      <aside className="products-page__sidebar">
        <h3>Categories</h3>
        <ul>
          {['All Products', 'Mens-Tshirts', 'Mens-Pants', 'Womens-Sports', 'Womens-Pants', 'Seamless-Bra', 'Womens-Shorts'].map((cat) => (
            <li key={cat} onClick={() => setSearchParams({ category: cat })} className={category === cat ? 'active' : ''}>
              {cat.replace('-', ' ')}
            </li>
          ))}
        </ul>
      </aside>
      <main className="products-page__main">
      <input type="text" placeholder="Search Products..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="search-bar" />
      <h2>{category.replace('-', ' ')}</h2>
      <div className="products-grid">
          {filteredProducts.length ? (
            filteredProducts.map((product) => (
              <div key={product.id} className="product-card flip-card" style={{ maxWidth: '300px', margin: 'auto' }}>
                <div className="flip-card-inner">
    {/* Front Side */}
    <div className="flip-card-front">
      <img src={product.image} alt={product.name} />
      <h4>{product.name}</h4>
    </div>
    
    {/* Back Side */}
    <div className="flip-card-back">
      <p>{product.description}</p>
    </div>
  </div>
              </div>
            ))
          ) : (
            <p>No products found.</p>
          )}
        </div>
      </main>
    </div>
    <Sloutions/>
    </>
  );
};

export default Products;
